import axios from 'axios';
import { DynamicObjectInterface } from '../type';
import { AxiosUtilsType, axiosDelete, axiosGet, axiosPost, axiosPut } from './axiosUtils';
import './axiosInterceptor';

const ParticipantService = {
  async addParticipant(parti: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`participant/add`, parti);
  },

  async getTeamParticipants(parti: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`participant/list`, parti);
  },

  async deleteTeamParticipant(recId: string, parti: DynamicObjectInterface): AxiosUtilsType {
    return await axiosDelete(`participant/list/${recId}`, parti);
  },

  async getAllParticipants(campaignId: string): AxiosUtilsType {
    return await axiosGet(`participant/campaign?id=${campaignId}`);
  },

  async getParticipantDetail(parti: DynamicObjectInterface, userId: string): AxiosUtilsType {
    return await axiosPost(`participant/list/${userId}`, parti);
  },

  async searchParticipant(loginId: string): AxiosUtilsType {
    return await axiosGet(`participant/search/${loginId}`);
  },

  async updateParticipantDetails(parti: DynamicObjectInterface, userId: string): AxiosUtilsType {
    return await axiosPut(`participant/list/${userId}?section=${parti?.section}`, parti);
  },

  async getParticipantHistory(payload?: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`participant/history`, payload);
  },

  async getCertificate(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`participant/certificate`, payload);
  },

  async downloadCertificate(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axios.post('participant/certificate/download', payload, {
      responseType: 'blob',
    });
  },

  // async updateParticipantPoint(parti: DynamicObjectInterface, userId: string): AxiosUtilsType {
  //   return await axiosPost(`participant/point/${userId}`, parti);
  // }

  async deletePurchaseProduct(ids: number[], userId: string): AxiosUtilsType {
    return await axiosDelete(`participant/product/${userId}`, ids);
  },

  async getTeamListByUser(userDtl: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`/participant/listTeamByUser`, userDtl);
  },

  async getParticipants(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`/participant/campaign/list`, payload);
  },

  async validatePin(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`/participant/validatePin`, payload);
  },
};
export default ParticipantService;
